export default {
  EASY: 10,
  MEDIUM: 20,
  HARD: 40,
  VERY_HARD: 32,
}
